/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EmployeeAvatarDto } from '../models';
/**
 * EmployeeProfileAvatarReaderRestApi - axios parameter creator
 * @export
 */
export const EmployeeProfileAvatarReaderRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfileAvatar: async (employeeId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getEmployeeProfileAvatar', 'employeeId', employeeId)
            const localVarPath = `/api/v2/employees/{employeeId}/avatar`
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmployeeProfileAvatarReaderRestApi - functional programming interface
 * @export
 */
export const EmployeeProfileAvatarReaderRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmployeeProfileAvatarReaderRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmployeeAvatarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmployeeProfileAvatar(employeeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmployeeProfileAvatarReaderRestApi.getEmployeeProfileAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmployeeProfileAvatarReaderRestApi - factory interface
 * @export
 */
export const EmployeeProfileAvatarReaderRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmployeeProfileAvatarReaderRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Employee Profile Avatar
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeAvatarDto> {
            return localVarFp.getEmployeeProfileAvatar(employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmployeeProfileAvatarReaderRestApi - interface
 * @export
 * @interface EmployeeProfileAvatarReaderRestApi
 */
export interface EmployeeProfileAvatarReaderRestApiInterface {
    /**
     * 
     * @summary Get Employee Profile Avatar
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarReaderRestApiInterface
     */
    getEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig): AxiosPromise<EmployeeAvatarDto>;

}

/**
 * EmployeeProfileAvatarReaderRestApi - object-oriented interface
 * @export
 * @class EmployeeProfileAvatarReaderRestApi
 * @extends {BaseAPI}
 */
export class EmployeeProfileAvatarReaderRestApi extends BaseAPI implements EmployeeProfileAvatarReaderRestApiInterface {
    /**
     * 
     * @summary Get Employee Profile Avatar
     * @param {string} employeeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmployeeProfileAvatarReaderRestApi
     */
    public getEmployeeProfileAvatar(employeeId: string, options?: RawAxiosRequestConfig) {
        return EmployeeProfileAvatarReaderRestApiFp(this.configuration).getEmployeeProfileAvatar(employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}

